var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ViewChild } from '@angular/core';
import { KeycloakService } from '../../services/keycloak.service';
import { CommonService } from '../../services/common.service';
import { ExpedienteService } from '../../services/expediente.service';
import { WizardComponent } from '../../common/wizard/wizard.component';
import { WizardStepComponent } from '../../common/wizard/wizard-step.component';
import { DatosDemandaComponent } from './datos-demanda.component';
import { PartesCausaComponent } from './partes-causa.component';
import { DemandaComponent } from './demanda.component';
import { FichaComponent } from './ficha.component';
import { FirmarComponent } from './firmar.component';
import { SIGNER_STATUS } from '../../common/firmador/firma-helper.component';
import { ServiceException } from '../../model/exception';
import { Message } from '../../common/dialog/mensaje.component';
import { MensajeConfig, BUTTON_CLICK } from '../../common/dialog/mensaje.config';
import { DatosIngresoComponent } from './datos-ingreso.component';
import { Organismo } from "../../model/organismo";
import { Secretaria } from "../../model/secretaria";
var NuevaCausaComponent = (function () {
    function NuevaCausaComponent(_service, _expService, _comService) {
        this._service = _service;
        this._expService = _expService;
        this._comService = _comService;
        this.isValidStep1 = false;
        this.isValidStep2 = false;
        this.isValidStep3 = false;
        this.isValidStepNew = false;
        this.showAfterComplete = false;
        this.cargaDatos = false;
        this.selectDatos = false;
        this.showPreview = true;
        this.instancia = 0;
        this.tex_cod = "";
        this.cir = 0;
        this.cir_desc = "";
        this.fue = 0;
        this.habil = true;
        this.msgDobleUnic = "";
        this.firmador = "";
        this.concep = { id: 0, cod: "", desc: "", fuero: "" };
        this.tex = { codigo: "", descr: "", forcar: "" };
        this.nuevaCausa = { habil: false, concepto: this.concep, tex: this.tex, nivel: 0, monto: "", cir_id: 0, cir_desc: "", observaciones: "", instancia: 0, caratula: "", partes: [] };
        this.blockingFlag = -1;
        this.ingDirecto = false;
        this.tipoIngreso = 0; // 0:Sorteo, 1:Directo, 2:Sorteo y Conexo, 3:Conexo
        this.checkStep2 = true;
        this.titulo = "POR SORTEO";
        this.tipoIng = 0; // 0:
        this.ingConexo = false;
        this.tex_cod_conexo = '';
        this.nro = '';
        this.anio = '';
        this.instanceId = Math.floor(Math.random() * 1000000);
    }
    NuevaCausaComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.blockingFlag = 2;
        //console.log("Nueva causa " + JSON.stringify(this.nuevaCausa));
        this.hideErrorMsg();
        this.hideErrorMsgConexo();
        this._service.findTiposIngreso().subscribe(function (response) {
            _this.tiposIngresoList = response;
            _this.isPageLoaded();
        });
        this._expService.findInstancias().subscribe(function (response) {
            _this.instList = response;
            _this.isPageLoaded();
        });
        // this._expService.findTiposExpediente().subscribe(response => {
        //     this.texList = response;
        //     this.isPageLoaded();
        // });
        this._service.findCir().subscribe(function (response) {
            _this.cirListOri = response;
            _this.recargarListas();
            _this.isPageLoaded();
        });
        this._service.findFue().subscribe(function (response) {
            _this.fueList = response;
            _this.isPageLoaded();
        });
        this._expService.findTiposExpedienteIurix().subscribe(function (response) {
            _this.texListConexo = response;
        });
        this.selectDatos = true;
    };
    NuevaCausaComponent.prototype.recargarListas = function () {
        var config_cir;
        if (this.tipoIngreso == 0) {
            config_cir = 'SOR_EXCIR';
        }
        else if (this.tipoIngreso == 1) {
            config_cir = 'DIR_EXCIR';
        }
        var cirConfiguradas = this._comService.getConfiguracion(config_cir);
        if (cirConfiguradas.length > 0) {
            this.cirList = this.deleteFromList(cirConfiguradas);
        }
        else {
            this.cirList = this.cirListOri;
        }
    };
    NuevaCausaComponent.prototype.deleteFromList = function (cirConfiguradas) {
        var array = [];
        this.cirListOri.forEach(function (element) {
            if (cirConfiguradas.indexOf(element.id.toString()) < 0) {
                array.push(element);
            }
        });
        //console.log(array);
        return array;
    };
    /*
        onClickDir(ev:Event){
            this.cir = 0;
            this.ingDirecto = !this.ingDirecto;
            if (this.ingDirecto){
                this.tipoIngreso = 1;
                this.titulo = "DIRECTO";
            }else{
                this.tipoIngreso = 0;
                this.titulo = "POR SORTEO";
            }
            
            console.log("tipoIngreso" + this.tipoIngreso);
            this.recargarListas();
        }
    */
    NuevaCausaComponent.prototype.onChangeSelectTiposIngreso = function (selected) {
        this.hideErrorMsgConexo();
        this.cir = 0;
        this.instancia = 0;
        this.fue = 0;
        this.tipoIng = selected;
        if (this.tipoIng == 2) {
            this.tipoIngreso = 3;
            this.titulo = "CONEXO";
            this.ingDirecto = false;
            this.ingConexo = true;
        }
        else if (this.tipoIng == 1) {
            this.tipoIngreso = 1;
            this.titulo = "DIRECTO";
            this.ingDirecto = true;
            this.ingConexo = false;
        }
        else {
            this.tipoIngreso = 0;
            this.titulo = "POR SORTEO";
            this.ingDirecto = false;
            this.ingConexo = false;
        }
        //console.log("tipoIngreso: " + this.titulo);
        //console.log("tipoIngreso" + this.tipoIngreso);
        //console.log("Directo " + this.ingDirecto);
        //console.log("Conexo " + this.ingConexo);
        this.recargarListas();
    };
    NuevaCausaComponent.prototype.onClickBuscarConexo = function () {
        var _this = this;
        this.hideErrorMsg();
        this.hideErrorMsgConexo();
        if (this.tex_cod_conexo != '' && this.nro !== '' && this.anio !== '') {
            this._expService.findExpConexo(this.tex_cod_conexo, this.nro, this.anio).subscribe(function (response) {
                if (response.expId != null) {
                    //console.log("busqueda conexo: "+ JSON.stringify(response));
                    _this.expConexo = response;
                    _this.secretaria = new Secretaria(_this.expConexo.secId, '', _this.expConexo.secretaria);
                    _this.orgSelected = new Organismo(_this.expConexo.orgId, '', _this.expConexo.organismo, null, _this.secretaria, _this.expConexo.depIdRad, _this.expConexo.sedDepIdRad, _this.expConexo.orgMultifueroRad);
                    _this.onChangeSelectCir(_this.expConexo.cirIdRad);
                    //console.log("cir ", this.cir);
                    _this.onChangeSelectInst(_this.expConexo.orgInsRad);
                    //console.log("instancia ", this.instancia);
                    _this.onChangeSelectFue(_this.expConexo.fueIdRad);
                    //console.log("fue ", this.fue);
                }
                else {
                    _this.expConexo = null;
                    _this.secretaria = null;
                    _this.ErrorMsgB = "No se ha encontrado el Expediente solicitado.";
                    _this.ErrorMessageIsVisibleB = true;
                    _this.validateData();
                }
            }, function (error) {
                _this.expConexo = null;
                _this.secretaria = null;
                _this.ErrorMsgB = "No se ha encontrado el Expediente solicitado.";
                _this.ErrorMessageIsVisibleB = true;
            });
        }
        else {
            this.ErrorMsgB = "Para buscar un Expediente conexo debe seleccionar el Tipo de Expediente, el Numero y Año.";
            this.ErrorMessageIsVisibleB = true;
        }
    };
    NuevaCausaComponent.prototype.isPageLoaded = function () {
        if (this.blockingFlag == 0) {
            this._service.emitBlocking(false);
        }
        else {
            this.blockingFlag = this.blockingFlag - 1;
        }
    };
    NuevaCausaComponent.prototype.onClickIniciar = function () {
        this.hideErrorMsg();
        this.hideErrorMsgConexo();
        if (this.validateData()) {
            if (this.instancia == 3 && this.cir != 1) {
                this.onAviso(this._comService.getConfiguracion('INSCIR_ERR'));
            }
            else {
                this.cargaDatos = true;
                this.selectDatos = false;
                this.showPreview = true;
                // this.datos.onComplete.subscribe((event:any) => { this.isValidStep1 = event; });
            }
        }
    };
    NuevaCausaComponent.prototype.validateData = function () {
        if (this.cir === 0) {
            this.showErrorMessage("Debe seleccionar la Circunscripción");
            return false;
        }
        if (this.instancia === 0) {
            this.showErrorMessage("Debe seleccionar la instancia");
            return false;
        }
        if (this.tex_cod === "") {
            this.showErrorMessage("Debe seleccionar un Tipo de Expediente");
            return false;
        }
        if (this.fue === 0) {
            this.showErrorMessage("Debe seleccionar el Fuero");
            return false;
        }
        return true;
    };
    NuevaCausaComponent.prototype.onChangeSelectInst = function (selected) {
        this.instancia = selected;
    };
    NuevaCausaComponent.prototype.onChangeSelectTipo = function (selected) {
        var _this = this;
        this.tex_cod = selected;
        this._expService.findTipoExp(this.tex_cod).subscribe(function (response) {
            _this.tipoExp = response;
        });
    };
    NuevaCausaComponent.prototype.onChangeSelectCir = function (selected) {
        // let config_cir:string;
        // let msg_cir:string;
        // if (this.tipoIngreso == 0){
        //     config_cir = 'SOR_EXCIR';
        //     msg_cir = 'SOR_MJEXCI';
        // }else{
        //     config_cir = 'DIR_EXCIR';
        //     msg_cir = 'DIR_MJEXCI';
        // }
        // let cirConfiguradas = this._comService.getConfiguracion(config_cir);
        // if (cirConfiguradas.length  > 0){
        //     if (cirConfiguradas.length  > 1 && cirConfiguradas == selected.toString()){
        //         this.onAviso(this._comService.getConfiguracion(msg_cir));
        //         this.cir = 0;
        //     }else{
        //         let cirSplit = cirConfiguradas.split(',');
        //         if (cirSplit.find(id => id == selected.toString())){
        //             this.onAviso(this._comService.getConfiguracion(msg_cir));
        //             this.cir = 0;
        //         }else{
        //             this.selectCir(selected);
        //         }
        //     }
        // }else{
        //     this.selectCir(selected);
        // }
        // console.log(selected);
        // console.log(this.cir);
        this.selectCir(selected);
    };
    NuevaCausaComponent.prototype.selectCir = function (selected) {
        this.cir = selected;
        var cirselect = this.cirList.find(function (item) { return item.id == selected; });
        this.cir_desc = cirselect.descr.toUpperCase();
    };
    NuevaCausaComponent.prototype.onChangeSelectFue = function (selected) {
        var _this = this;
        this.fue = selected;
        this._expService.findTiposExpedienteByFue(selected).subscribe(function (response) {
            _this.texList = response;
            _this.isPageLoaded();
        });
        // var cirselect: Circunscripcion = this.cirList.find(item => item.id == selected);
        // this.cir_desc = cirselect.descr.toUpperCase();
    };
    NuevaCausaComponent.prototype.onChangeSelectTipoExpConexo = function (selected) {
        this.tex_cod_conexo = selected;
    };
    NuevaCausaComponent.prototype.onStep1Next = function (ev) {
        this.nuevaCausa = this.datos.causa;
        this.nuevaCausa.instancia = this.instancia;
        this.nuevaCausa.cir_id = this.cir;
        this.nuevaCausa.cir_desc = this.cir_desc;
        this.nuevaCausa.tex = this.tipoExp;
        this.nuevaCausa.observaciones = this.nuevaCausa.observaciones.toUpperCase();
        this.partes.ttr_id = this.nuevaCausa.concepto.id;
        this.partes.findTiposVunculoByConcepto();
        if (this.ingDirecto) {
            this.ingreso.load();
        }
        else if (this.ingConexo && this.expConexo != null && this.expConexo.expId != null) {
            this.nuevaCausa.expConexo = this.expConexo.expId;
            this.partes.buscarPerConexo(this.nuevaCausa.expConexo);
            this.nuevaCausa.orgDestino = this.orgSelected;
            this.nuevaCausa.secDestino = this.secretaria;
        }
    };
    NuevaCausaComponent.prototype.onStepNewNext = function (ev) {
        // if (this.tex_cod === 'EXP' && (this.ingDirecto && this.ingreso.conexo)){
        //     this.msgPopup.onClick.subscribe((event:any) => { this.onOkConexo(event) });
        //     this.onNextConexo("ALGO");                        
        // }  
        // console.log("exp conexo " + JSON.stringify(this.ingreso.expConexo));
        if (this.ingreso.conexo && this.ingreso.expConexo != null && this.ingreso.expConexo != undefined) {
            if (this.nuevaCausa.expConexo !== this.ingreso.expConexo.expId) {
                this.nuevaCausa.expConexo = this.ingreso.expConexo.expId;
                this.partes.buscarPerConexo(this.ingreso.expConexo.expId);
            }
        }
        else {
            this.partes.partes = [];
        }
        if (this.ingreso.ingreso || this.ingreso.conexo) {
            this.nuevaCausa.orgDestino = this.ingreso.orgSelected;
            this.nuevaCausa.secDestino = this.ingreso.secretaria;
        }
    };
    NuevaCausaComponent.prototype.onCompleteStep1 = function (ev) {
        this.isValidStep1 = ev;
    };
    NuevaCausaComponent.prototype.onCompleteStepNew = function (ev) {
        //console.log("complete new " + ev);
        this.isValidStepNew = ev;
    };
    NuevaCausaComponent.prototype.onStep2Next = function (ev) {
        this.nuevaCausa.partes = this.partes.partes;
        this.nuevaCausa.caratula = this.getCaratula();
        //console.log("NUEVA CAUSA " + JSON.stringify(this.nuevaCausa));
    };
    NuevaCausaComponent.prototype.onCompleteStep2 = function (ev) {
        this.isValidStep2 = ev;
    };
    NuevaCausaComponent.prototype.getCaratula = function () {
        if (this.nuevaCausa.tex.forcar == "")
            return "";
        var caratula = "";
        var formatoCarat = this.nuevaCausa.tex.forcar;
        var act = "";
        var dem = "";
        var otroVin = "";
        act = this.getPartesCaratula('ACT');
        dem = this.getPartesCaratula('DEM');
        otroVin = this.getPartesCaratula('OTR');
        caratula = formatoCarat;
        if (caratula.indexOf('#A#') !== -1) {
            caratula = caratula.replace('#A#', act);
        }
        if (caratula.indexOf('#B#') !== -1) {
            caratula = caratula.replace('#B#', dem);
            if (dem === '') {
                caratula = caratula.replace('C/ ', '');
            }
        }
        if (caratula.indexOf('#C#') !== -1) {
            caratula = caratula.replace('#C#', otroVin);
        }
        if (caratula.indexOf('#O#') !== -1) {
            caratula = caratula.replace('#O#', this.nuevaCausa.concepto.desc);
        }
        return caratula.toUpperCase();
    };
    NuevaCausaComponent.prototype.getPartesCaratula = function (vin) {
        var parteString = '';
        this.nuevaCausa.partes.filter(function (par) {
            if (vin === 'OTR') {
                //console.log('otros vinculos');
                //console.log('vinculo ' + par.tipoVin.cod);
                //console.log('parte ' + par.apellido + " " + par.nombre);
                //console.log('excluir vinculos ' + par.tipoVin.excluirForcar);
                if (par.tipoVin.cod !== 'ACT' && par.tipoVin.cod !== 'DEM' && !par.tipoVin.excluirForcar) {
                    if (parteString === '') {
                        parteString = (par.apellido != null ? par.apellido : '') + ' ' + par.nombre;
                    }
                    else {
                        parteString = parteString + '-' + (par.apellido != null ? par.apellido : '') + ' ' + par.nombre;
                    }
                }
            }
            else {
                if (par.tipoVin.cod === vin) {
                    if (parteString === '') {
                        parteString = (par.apellido != null ? par.apellido : '') + ' ' + par.nombre;
                    }
                    else {
                        parteString = parteString + '-' + (par.apellido != null ? par.apellido : '') + ' ' + par.nombre;
                    }
                }
            }
        });
        if (parteString.split('-').length > 2) {
            var tmp = parteString.split('-')[0] + ', ' + parteString.split('-')[1] + ' Y OTROS';
            parteString = tmp;
        }
        else {
            parteString = parteString.replace('-', ', ');
        }
        return parteString;
    };
    NuevaCausaComponent.prototype.onStep3Next = function (ev) {
        this.showPreview = false;
        this.nuevaCausa.file = this.files.demanda;
        this.nuevaCausa.adj = this.files.files;
        //console.log("causa" + JSON.stringify(this.nuevaCausa));
    };
    NuevaCausaComponent.prototype.onCompleteStep3 = function (ev) {
        this.isValidStep3 = ev;
        //console.log("causa" + JSON.stringify(this.nuevaCausa));
    };
    NuevaCausaComponent.prototype.onStep4Prev = function (ev) {
        this.showPreview = true;
        //console.log("causa" + JSON.stringify(this.nuevaCausa));
    };
    NuevaCausaComponent.prototype.onCancelar = function (ev) {
        this.cargaDatos = false;
        this.selectDatos = true;
        this.isValidStep1 = false;
        this.isValidStep2 = false;
        this.isValidStep3 = false;
        this.showAfterComplete = false;
        this.cir = 0;
        this.fue = 0;
        this.cir_desc = "";
        this.instancia = 0;
        this.tex_cod = "";
        this.concep = { id: 0, cod: "", desc: "", fuero: "" };
        this.tex = { codigo: "", descr: "", forcar: "" };
        this.nuevaCausa = { habil: false, concepto: this.concep, tex: this.tex, nivel: 0, monto: "", cir_id: 0, cir_desc: "", observaciones: "", instancia: 0, caratula: "", partes: [] };
        this.nuevoExp = null;
        this.msgDobleUnic = "";
        this.ingDirecto = false;
        this.checkStep2 = true;
        this.tipoIngreso = 0;
        this.titulo = "POR SORTEO";
        this.tipoIng = 0;
        this.ingConexo = false;
        this.tex_cod_conexo = '';
        this.nro = '';
        this.anio = '';
        this.expConexo = null;
        this.secretaria = null;
        this.orgSelected = new Organismo(0, '', null, null, null, null, null, null);
        this.recargarListas();
    };
    NuevaCausaComponent.prototype.showErrorMessage = function (msg) {
        this.ErrorMsg = msg;
        this.ErrorMessageIsVisible = true;
    };
    NuevaCausaComponent.prototype.showSuccessMessage = function (msg) {
        this.SuccessMsg = msg;
        this.SuccessMessageIsVisible = true;
    };
    NuevaCausaComponent.prototype.hideErrorMsg = function () {
        this.ErrorMsg = "";
        this.ErrorMessageIsVisible = false;
        this.hideSuccessMsg();
    };
    NuevaCausaComponent.prototype.hideSuccessMsg = function () {
        this.SuccessMsg = "";
        this.SuccessMessageIsVisible = false;
    };
    NuevaCausaComponent.prototype.hideErrorMsgConexo = function () {
        this.ErrorMsgB = "";
        this.ErrorMessageIsVisibleB = false;
    };
    NuevaCausaComponent.prototype.mostrarFuero = function () {
        var res = false;
        if (JSON.stringify(this.nuevaCausa) !== 'undefined' && JSON.stringify(this.nuevaCausa.concepto) !== 'undefined') {
            res = true;
        }
        return res;
    };
    NuevaCausaComponent.prototype.imprimirReporte = function (ev) {
        var _this = this;
        var that = this;
        var fileName = "ingreso_causa" + this.nuevoExp.numero + ".pdf";
        var a = document.createElement("a");
        document.body.appendChild(a);
        this._expService.imprimirReporte(JSON.stringify(this.nuevoExp.expId), false, KeycloakService.getLoggedUser()).subscribe(function (response) {
            var file = new Blob([response], { type: 'application/pdf' });
            var fileURL = window.URL.createObjectURL(file);
            a.href = fileURL;
            a.download = fileName;
            a.click();
        }, function (error) {
            _this.showErrorMessage("No se pudo generar el Reporte");
        });
    };
    /*
        onFirmaWizard(ev: any) {
            //chequear doble iniciacion, debe tener al menos un act y un dem
            var act = this.tieneActDem("ACT");
            var dem = this.tieneActDem("DEM");
            if (this._service.getCheckDouble() && act != null && dem != null){
                console.log("busca doble iniciacion");
                this.msgPopup.onClick.subscribe((event:any) => { this.onOkDoble(event) });
                this._service.emitBlocking(true);
                var that = this;
                this._expService.findDobleIniciacion(String(act),String(dem)).subscribe((result) => {
                    this._service.emitBlocking(false);
                    if (result.numero != null){
                        console.log("encontro doble iniciacion");
                        this.msgDobleUnic = "Expediente " + result.tipo + " " + result.numero + "/" + result.anio + ", " + result.caratula + " Radicado en el organismo " + result.organismo;
                        this.onMensaje(this.msgDobleUnic, "Posible Doble Iniciacion");
                    }else{
                        console.log("NO encontro doble iniciacion");
                        this.loadFile();
                    }
                }, (error: Response) => {
                    this._service.emitBlocking(false);
                    var exc = ServiceException.parse(error.json());
                    console.log(exc.toString());
                    this.loadFile();
                });
            }else{
                this.loadFile();
            }
        }
    */
    NuevaCausaComponent.prototype.onFirmaWizard = function (ev) {
        var _this = this;
        //chequear doble iniciacion
        //console.log("doble iniciacion partes" + JSON.stringify(this.nuevaCausa.partes));
        //console.log("doble iniciacion concepto" + JSON.stringify(this.nuevaCausa.concepto));
        var jsonPartes = this.nuevaCausa.partes.map(function (parte) { return ({
            per_id: parte.per_id,
            tvi_id: parte.tipoVin.id
        }); });
        //console.log("jsonPartes" + JSON.stringify(jsonPartes));
        //console.log("verifica doble iniciacion " + this._service.getCheckDouble());
        if (this._service.getCheckDouble()) {
            //console.log("busca doble iniciacion");
            this.msgPopup.onClick.subscribe(function (event) { _this.onOkDoble(event); });
            this._service.emitBlocking(true);
            var that = this;
            this._expService.findDobleIniciacion(JSON.stringify(jsonPartes), String(this.nuevaCausa.concepto.id)).subscribe(function (result) {
                _this._service.emitBlocking(false);
                if (result.numero != null) {
                    //console.log("encontro doble iniciacion");
                    _this.msgDobleUnic = "Expediente " + result.tipo + " " + result.numero + "/" + result.anio + ", " + result.caratula + " Radicado en el organismo " + result.organismo;
                    _this.onMensaje(_this.msgDobleUnic, "Posible Doble Iniciacion");
                }
                else {
                    //console.log("NO encontro doble iniciacion");
                    _this.msgDobleUnic = "";
                    _this.loadFile();
                }
            }, function (error) {
                _this._service.emitBlocking(false);
                var exc = ServiceException.parse(error.json());
                //console.log(exc.toString());
                _this.loadFile();
            });
        }
        else {
            this.loadFile();
        }
    };
    NuevaCausaComponent.prototype.tieneActDem = function (vin) {
        for (var i = 0; this.nuevaCausa.partes.length > i; i++) {
            if (this.nuevaCausa.partes[i].per_id != null && this.nuevaCausa.partes[i].tipoVin.cod == vin) {
                return this.nuevaCausa.partes[i].per_id;
            }
        }
        return null;
    };
    NuevaCausaComponent.prototype.loadFile = function () {
        var reader = new FileReader();
        var that = this;
        this._service.emitBlocking(true);
        var fileName64 = that.nuevaCausa.file[0].name;
        fileName64 = fileName64.replace(/[\u00A0-\u2666\u00F1\u00D1]/g, function (c) {
            return '&#' + c.charCodeAt(0) + ';';
        });
        //console.log("REMPALAZO NAME FILE " + that.nuevaCausa.file[0].name + " TO " + fileName64);
        var ext = fileName64.substring(fileName64.indexOf("."));
        //console.log("extension file " + ext);
        //console.log("name sin extension " + fileName64.substring(0, fileName64.indexOf(".")));
        //console.log("no mas de 30 " + fileName64.substring(0, fileName64.indexOf(".")).substring(0, 15));
        fileName64 = fileName64.substring(0, fileName64.indexOf(".")) + ext;
        reader.onloadend = function () {
            that._expService.uploadDocumento("demanda;" + fileName64, reader.result).subscribe(function (result) {
                that.demandaUploaded(result);
            }, function (error) {
                that._service.emitBlocking(false);
                var exc = ServiceException.parse(error.json());
                //console.log(exc.toString());
                alert(exc.description);
            });
        };
        if (that.nuevaCausa.file) {
            reader.readAsDataURL(that.nuevaCausa.file[0]);
        }
    };
    NuevaCausaComponent.prototype.demandaUploaded = function (fileId) {
        //console.log("upload: " + JSON.stringify(fileId));
        var reader = new FileReader();
        var nam = "";
        var that = this;
        for (var i = 0; that.nuevaCausa.adj.length > i; i++) {
            this.setupAdjReader(that.nuevaCausa.adj[i], fileId.id);
        }
        this.nuevaCausa.fileId = fileId.id;
        this.firmar.open(fileId.name, fileId.id, "demanda");
        $('#firmar-' + this.instanceId).modal({
            backdrop: 'static',
            keyboard: false
        });
        $('#firmar-' + this.instanceId).modal('show');
    };
    NuevaCausaComponent.prototype.setupAdjReader = function (file, id) {
        var name = file.name;
        var reader = new FileReader();
        var that = this;
        var fileName64 = name;
        fileName64 = fileName64.replace(/[\u00A0-\u2666\u00F1\u00D1]/g, function (c) {
            return '&#' + c.charCodeAt(0) + ';';
        });
        //console.log("REMPALAZO NAME FILE " + name + " TO " + fileName64);
        var ext = fileName64.substring(fileName64.indexOf("."));
        //console.log("extension file " + ext);
        //console.log("name sin extension " + fileName64.substring(0, fileName64.indexOf(".")));
        //console.log("no mas de 30 " + fileName64.substring(0, fileName64.indexOf(".")).substring(0, 15));
        fileName64 = fileName64.substring(0, fileName64.indexOf(".")) + ext;
        reader.onloadend = function () {
            that._expService.uploadAdjunto(id, "adjunto;" + fileName64, reader.result).subscribe(function (result) {
            }, function (error) {
                console.error(error);
                alert(error);
            });
        };
        reader.readAsDataURL(file);
    };
    NuevaCausaComponent.prototype.selFirmador = function (event) {
        //console.log("firmador evento " + event);
        this.firmador = event;
    };
    NuevaCausaComponent.prototype.modalEscritoEvent = function (event) {
        var _this = this;
        //console.log("insert expediente");
        this.msgPopup.onClick.subscribe(function (event) { _this.onOkSussess(event); });
        switch (event) {
            case SIGNER_STATUS.SIGNOK.code:
                //console.log("demanda firmada!");
                this._service.emitBlocking(true);
                //console.log("datos de la conexidad");
                if (this.nuevaCausa.expConexo != null) {
                    //this.nuevaCausa.observaciones = this.nuevaCausa.observaciones + " Ingresado por Conexidad: " + this.ingreso.expConexo.tipo + " " + this.ingreso.expConexo.numero + "/" + this.ingreso.expConexo.anio;
                    this.nuevaCausa.observaciones = this.nuevaCausa.observaciones + " Ingresado por Conexidad: " + this.expConexo.tipo + " " + this.expConexo.numero + "/" + this.expConexo.anio;
                }
                if (this.msgDobleUnic != "") {
                    this.nuevaCausa.observaciones = this.nuevaCausa.observaciones + " Posible Doble Iniciacion " + this.msgDobleUnic;
                }
                //console.log("firmador " + this.firmador);
                this.nuevaCausa.firmador = this.firmador;
                //console.log("causa" + JSON.stringify(this.nuevaCausa));
                this._expService.insertExp(JSON.stringify(this.nuevaCausa), this.nuevaCausa.fileId).subscribe(function (response) {
                    _this.nuevoExp = response;
                    _this._service.emitBlocking(false);
                    if (_this.nuevoExp.problema != null) {
                        _this.onAviso(_this.nuevoExp.problema);
                    }
                    else {
                        _this.finalice();
                    }
                }, function (error) {
                    _this._service.emitBlocking(false);
                    _this.mensajeConfigSource = new MensajeConfig("Ingreso de Causas", false, "", true, "Aceptar");
                    _this.msgPopup.showMessage("No se pudo realizar el sorteo del expediente. Comuníquese con soporte para verificar la configuración.");
                });
                break;
            case SIGNER_STATUS.CLOSED.code:
                $('#firmar-' + this.instanceId).modal('hide');
                //console.log("modal firmar cerrado");
                break;
        }
    };
    NuevaCausaComponent.prototype.onAviso = function (sms, tit) {
        if (tit === void 0) { tit = "Ingreso de Causas"; }
        this.mensajeConfigSource = new MensajeConfig(tit, false, "", true, "Aceptar");
        this.msgPopup.showMessage(sms);
    };
    NuevaCausaComponent.prototype.onMensaje = function (sms, tit) {
        if (tit === void 0) { tit = "Ingreso de Causas"; }
        this.mensajeConfigSource = new MensajeConfig(tit, true, "Continuar");
        this.msgPopup.showMessage(sms);
    };
    NuevaCausaComponent.prototype.onNextConexo = function (sms, tit) {
        if (tit === void 0) { tit = "Ingreso de Causas"; }
        this.mensajeConfigSource = new MensajeConfig(tit, true, "Aceptar", true, "Cancelar");
        this.msgPopup.showMessage(sms);
    };
    NuevaCausaComponent.prototype.onOkSussess = function (res) {
        this.finalice();
    };
    NuevaCausaComponent.prototype.onOkDoble = function (res) {
        if (res == BUTTON_CLICK.Aceptar) {
            this.loadFile();
        }
    };
    NuevaCausaComponent.prototype.onOkConexo = function (res) {
        //console.log("res " + res);
        if (res == BUTTON_CLICK.Aceptar) {
            this.checkStep2 = false;
            this.wiz.next();
            this.wizStep.checkBeforeNext = false;
        }
        else {
            this.wizStep.checkBeforeNext = true;
        }
    };
    NuevaCausaComponent.prototype.finalice = function () {
        this.ficha.fecha = new Date(this.nuevoExp.fecha);
        //console.log(this.wiz.activeStep.title);
        this.wiz.activeStep.firma = false;
        this.wiz.complete();
    };
    return NuevaCausaComponent;
}());
__decorate([
    ViewChild(DatosDemandaComponent),
    __metadata("design:type", DatosDemandaComponent)
], NuevaCausaComponent.prototype, "datos", void 0);
__decorate([
    ViewChild(DatosIngresoComponent),
    __metadata("design:type", DatosIngresoComponent)
], NuevaCausaComponent.prototype, "ingreso", void 0);
__decorate([
    ViewChild(PartesCausaComponent),
    __metadata("design:type", PartesCausaComponent)
], NuevaCausaComponent.prototype, "partes", void 0);
__decorate([
    ViewChild(DemandaComponent),
    __metadata("design:type", DemandaComponent)
], NuevaCausaComponent.prototype, "files", void 0);
__decorate([
    ViewChild(FichaComponent),
    __metadata("design:type", FichaComponent)
], NuevaCausaComponent.prototype, "ficha", void 0);
__decorate([
    ViewChild(WizardComponent),
    __metadata("design:type", WizardComponent)
], NuevaCausaComponent.prototype, "wiz", void 0);
__decorate([
    ViewChild(WizardStepComponent),
    __metadata("design:type", WizardStepComponent)
], NuevaCausaComponent.prototype, "wizStep", void 0);
__decorate([
    ViewChild(FirmarComponent),
    __metadata("design:type", FirmarComponent)
], NuevaCausaComponent.prototype, "firmar", void 0);
__decorate([
    ViewChild(Message),
    __metadata("design:type", Message)
], NuevaCausaComponent.prototype, "msgPopup", void 0);
NuevaCausaComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'nueva-causa',
        templateUrl: 'nueva-causa.component.html'
    }),
    __metadata("design:paramtypes", [CommonService, ExpedienteService, CommonService])
], NuevaCausaComponent);
export { NuevaCausaComponent };
//# sourceMappingURL=nueva-causa.component.js.map